import { createSlice } from '@reduxjs/toolkit';

interface TherapyState {
  clearSearch: boolean;
}

const initialState: TherapyState = {
  clearSearch: false,
};

const therapySlice = createSlice({
  name: 'therapy',
  initialState,
  reducers: {
    clearSearch: (state) => {
      state.clearSearch = true;
    },
    resetClearSearch: (state) => {
      state.clearSearch = false;
    },
  },
});

export const therapyActions = therapySlice.actions;

export default therapySlice.reducer;
